import { Component, OnInit } from '@angular/core';
import {fuseAnimations} from "@fuse/animations";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FuseConfigService} from "@fuse/services/config.service";
import {ResetPasswordService} from "@app/auth/reset-password/reset-password.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations : fuseAnimations
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  resetPasswordFormErrors: any;
  accessToken: string;

  constructor(
    private fuseConfig: FuseConfigService,
    private snackBar: MatSnackBar,
    private _resetPasswordService: ResetPasswordService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder) {
    this.fuseConfig.setConfig({
      layout: {
        navigation: 'none',
        toolbar   : 'none',
        footer    : 'none'
      }
    });

    this.resetPasswordFormErrors = {
      email          : {},
      password       : {},
      passwordConfirm: {}
    };
  }

  ngOnInit() {

    if (!this.activatedRoute.snapshot.queryParams.hasOwnProperty('access_token')) {
      this.router.navigate(['/auth/login']);
    }
    this.accessToken = this.activatedRoute.snapshot.queryParams['access_token'];

    this.resetPasswordForm = this.formBuilder.group({
      password       : ['', Validators.required],
      passwordConfirm: ['', [Validators.required, confirmPassword]]
    });

    this.resetPasswordForm.valueChanges.subscribe(() => {
      this.onResetPasswordFormValuesChanged();
    });
  }

  onResetPasswordFormValuesChanged() {
    for ( const field in this.resetPasswordFormErrors ) {
      if ( !this.resetPasswordFormErrors.hasOwnProperty(field) ) {
        continue;
      }

      // Clear previous errors
      this.resetPasswordFormErrors[field] = {};

      // Get the control
      const control = this.resetPasswordForm.get(field);

      if ( control && control.dirty && !control.valid ) {
        this.resetPasswordFormErrors[field] = control.errors;
      }
    }
  }

  onResetPassSubmit(): void {
    this._resetPasswordService.resetPassword(this.resetPasswordForm.value.password, this.accessToken).subscribe(
      () => {
        const message = 'Your password has been updated successfully, try signing in.';
        this.snackBar.open(message, 'OK', {
          verticalPosition: 'top'
        });
      },
      error => {
        const message = 'Sorry, we can\'t setup your new password, please try again or contact administrator.';
        this.snackBar.open(message, 'OK', {
          verticalPosition: 'top'
        });
      }
    );
  }
}

function confirmPassword(control: AbstractControl) {
  if ( !control.parent || !control ) {
    return;
  }

  const password = control.parent.get('password');
  const passwordConfirm = control.parent.get('passwordConfirm');

  if ( !password || !passwordConfirm ) {
    return;
  }

  if ( passwordConfirm.value === '' ) {
    return;
  }

  if ( password.value !== passwordConfirm.value ) {
    return {
      passwordsNotMatch: true
    };
  }
}
